const gridBtn = document.querySelector("#grid-view");
const mapBtn = document.querySelector("#map-view");
const filter = document.querySelector("#select-filter");
const schoolList = document.querySelector('.school-list');
const schoolMap = document.querySelector('.school-map');

if(gridBtn) {
    gridBtn.addEventListener('click', function () {
        gridBtn.classList.add('is-active');
        mapBtn.classList.remove('is-active');
        schoolList.classList.add('is-visible');
        schoolMap.classList.remove('is-visible');
        filter.classList.add('is-visible');
    });
}

if(mapBtn) {
    mapBtn.addEventListener('click', function () {
        gridBtn.classList.remove('is-active');
        mapBtn.classList.add('is-active');
        schoolList.classList.remove('is-visible');
        schoolMap.classList.add('is-visible');
        filter.classList.remove('is-visible');
    });
}
